export const statusIcons = {
    cyan: "bi:chat-right-text-fill",
    red: "bi:diamond-fill",
    green: "fluent:triangle-down-12-filled",
    orange: "fluent:circle-24-filled",
    skyblue: "ant-design:tool-filled",
}
